/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
    'file-earmark-play': {
        width: 16,
        height: 16,
        viewBox: '0 0 16 16',
        data: '<path pid="0" d="M6 6.883v4.234a.5.5 0 00.757.429l3.528-2.117a.5.5 0 000-.858L6.757 6.454a.5.5 0 00-.757.43z"/><path pid="1" d="M14 14V4.5L9.5 0H4a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2M9.5 3A1.5 1.5 0 0011 4.5h2V14a1 1 0 01-1 1H4a1 1 0 01-1-1V2a1 1 0 011-1h5.5z"/>',
    },
});
